module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.html
// module id = ./src/app/components/login/login.component.html
// module chunks = main